import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavToolbarComponent } from './nav-toolbar.component';
import { ButtonGroupModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { NavToolbarService } from './nav-toolbar.service';

@NgModule({
  imports: [
    CommonModule,
    ButtonGroupModule,
    ButtonsModule,
  ],
  declarations: [NavToolbarComponent],
  providers: [NavToolbarService],
  exports: [NavToolbarComponent]
})
export class NavToolbarModule { }
